// The API sends the property attributes as English text ("8 guests", "6 beds", "3 baths + 1 WC", "pool",
// "190 m<sup>2</sup> indoor"). Translate only the unit words, with the units.* keys of the page language.
// Languages without these keys (the Lodge leaves them in English) keep the English words.
const UNIT_WORDS = [ 'guests', 'guest', 'beds', 'bed', 'baths', 'bath', 'pools', 'pool', 'indoor', 'outdoor' ];

export function localizeUnits ( value: any, t: ( key: string ) => string ): any {
  if ( typeof value !== 'string' || value === '' ) {
    return value;
  }
  return value.replace( new RegExp( '\\b(' + UNIT_WORDS.join( '|' ) + ')\\b', 'g' ), ( word ) => {
    const translated = t( 'units.' + word );
    return translated && translated !== 'units.' + word ? translated : word;
  } );
}
